import { getFocusableElements } from '@adac-mp/shared';
import { useEffect, useRef } from 'react';

export const useFocusableElements = (element: React.MutableRefObject<HTMLElement | null>, condition: boolean) => {
	const firstFocusableRef = useRef<HTMLElement | null>();
	const lastFocusableRef = useRef<HTMLElement | null>();

	useEffect(() => {
		if (condition) {
			const { firstFocusableElement, lastFocusableElement } = getFocusableElements(element);

			firstFocusableRef.current = firstFocusableElement;
			lastFocusableRef.current = lastFocusableElement;

			firstFocusableElement.focus();
		}
	}, [condition]);

	const onKeyDown = (e) => {
		const { firstFocusableElement, lastFocusableElement } = getFocusableElements(element);

		firstFocusableRef.current = firstFocusableElement;
		lastFocusableRef.current = lastFocusableElement;

		if (document.activeElement === lastFocusableElement && e.key === 'Tab' && !e.shiftKey) {
			e.preventDefault();
			firstFocusableElement.focus();
		}

		if (document.activeElement === firstFocusableElement && e.key === 'Tab' && e.shiftKey) {
			e.preventDefault();
			lastFocusableElement.focus();
		}
	};

	return {
		firstFocusableElement: firstFocusableRef.current,
		lastFocusableElement: lastFocusableRef.current,
		onKeyDown,
	};
};
